import { useRoadworkWithTasks } from "./queries/useRoadwork"

export function useIsNewRoadwork(roadworkId, road) {
    const { data: roadwork } = useRoadworkWithTasks(roadworkId, road, { enabled: !!roadworkId })

    if (!roadworkId) {
        return true
    }

    return !roadwork?.tasks?.length
}